import useAuth from '../../../app/src/features/authentication/hooks/useAuth';
import { setQueryParam } from '../../../common/src/hooks/query-params/useAddQueryParam';
import { flowIdAskaTravelContract } from '../../../flows/src/constants/flowIds';
import useFlowsInitNew from '../../../flows/src/hooks/init/useFlowsInitNew';
import useFlowsResetState from '../../../flows/src/hooks/useFlowsResetState';

const useStartAskaTravelContractFlow = () => {
  const { user } = useAuth();
  const { initFlow } = useFlowsInitNew();
  const { reset } = useFlowsResetState();

  return async (
    uuid?: string,
    inputUrl?: string,
    partyId?: string,
    quoteIds?: string[],
  ) => {
    reset();

    await initFlow({
      flowId: flowIdAskaTravelContract,
      payload: {
        party_id: partyId,
        quote_ids: quoteIds,
        previous_session_id: uuid,
      },
      inputUrl,
      outputUrl: setQueryParam(`/aska-travel/finalize`, {
        broker_id: user?.id,
      }),
      sessionId: uuid,
      shouldComplete: false,
    });
  };
};

export default useStartAskaTravelContractFlow;
